import React from 'react';
import { Icon } from './Icon.js';
export const IconDuplicate = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M15.8294 7.99993L14.0962 1.53907L1.53916 4.90372L4.90381 17.4608L8 16.6311", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21 21L21 8L8 8L8 21L21 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDuplicate.js.map